module.exports = __webpack_public_path__ + "static/media/direction.b0a8548e.svg";